import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=cae0166e&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&id=cae0166e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae0166e",
  null
  
)

export default component.exports